import { Route, Switch } from "react-router-dom";

import Project from "src/app/modules/user-projects/Details";
import Projects from "src/app/modules/user-projects/Table";
import { ROUTES } from "src/config/constants";

import Active from "./components/ActiveTable";
import Blocked from "./components/BlockedTable";

function Users() {
  return (
    <div className="u-bg-background">
      <Switch>
        <Route path={ROUTES.adminUsersActive} component={Active} />
        <Route path={ROUTES.adminUsersBlocked} component={Blocked} />
        <Route path={ROUTES.adminUserProjects} component={Projects} />
        <Route path={ROUTES.adminUserProject} component={Project} />
      </Switch>
    </div>
  );
}

export default Users;
